import React, { useEffect, useState } from "react";
import "../styles.css";
import "bootstrap/dist/css/bootstrap.css";
import "./settings.css"
import Pipline from "./Pipline";
import Deal from "./Deal"
import SupportLink from "../Common/SupportLink";


function All(props) {
    const [currentTab, setCurrentTab] = useState("pipline");
    const PIPLINE_TAB = {
        name: 'Pipelines',
        id: 'pipline',
        status: 'active',
        //icon: 'fas fa-envelope',
        tab: 'pipline',
    };
    const Deal_TAB = {
        name: 'Deals',
        id: 'Deals',
        status: '',
        //  icon: 'fas fa-globe',
        tab: 'Deals',
    };
    const TABS = [Deal_TAB, PIPLINE_TAB

    ];
    const tabChanged = (tab) => {
        TABS.map(t => {
            if (t.id === tab.id)
                t.status = 'active'
            else
                t.status = ''
        })



        setCurrentTab(tab.id)
    };
    const NavTab = (tab) => {
        let currentStatus = '';
        if (currentTab === tab.tabinfo.id) {
            currentStatus = 'active';
        } else {
            currentStatus = '';
        }
        return (
            <li className='nav-item'>
                <a
                    onClick={() => {
                        tab.tabChanged(tab.tabinfo);
                    }}
                    className={`nav-link ${currentStatus}`}
                    href={'#' + tab.tabinfo.id}
                    role='tab'
                    data-toggle='tab'
                    key={tab.key_id}
                >
                    <i className={tab.tabinfo.icon}></i> {tab.tabinfo.name}
                </a>
            </li>
        );
    };

    return (
        <div className='templates'>
            <SupportLink link='https://kapitalwise.com/user-guide/settings#objects_setup' />

            <div className='page_heading'>
                <h2>Configuration</h2>
            </div>

            <div className='cmpgn_list_outer'>
                <div className='cmpgn_tab_erap'>
                    <ul className='nav nav-tabs' role='tablist'>
                        {TABS.map((tab, index) => {
                            return (
                                <NavTab
                                    key={index}
                                    key_id={tab.id}
                                    tabChanged={tabChanged}
                                    tabinfo={tab}
                                />
                            );
                        })}
                    </ul>
                </div>

            </div>

            {currentTab == 'pipline' ?

                <Pipline />
                :
                <Deal />

            }


        </div>
    );
}
export default All;
